import { useChangePassword } from "../authentication/useChangePassword";
import classNames from "classnames";
import { useAuth, useModal } from "@/comn/hooks";
import { useEffect } from "react";
import { InputPassword } from "@/comn/components/_";

const imgs = {
    imgLock: `${process.env.PUBLIC_URL}/imgs/img-lock.png`,
};

const ChangePassword = () => {
    const auth = useAuth();
    const { changePasswordForm, setChangePasswordForm, handleSubmitChange, handleSubmitChangeSkip } =
        useChangePassword();

    const { usrPwd, newUsrPwd, newUsrPwdCheck } = changePasswordForm;

    useEffect(() => {
        setChangePasswordForm({ ...changePasswordForm, usrId: auth.get("usrId") });
    }, []);

    return (
        <div className="w-full h-auto lg:h-[calc(100vh-140px)] flex items-center relative">
            <div className="find-content-wrap w-full h-auto top-0 left-0 flex items-center justify-center my-[90px] ">
                <div className={classNames("find-content-min w-full md:w-[520px] lg:w-[520px] h-auto relative")}>
                    <img
                        src={imgs["imgLock"]}
                        width={"700px"}
                        height={"auto"}
                        className="grayscale opacity-10 absolute top-[100px] -left-[300px] -z-[1] hidden md:block lg:block"
                    />
                    <div className="find-header bg-primary p-[30px] relative rounded-t-[30px]">
                        <h2 className="text-2xl text-white">Change Password</h2>
                        <span className="block w-[214px] lg:w-[214px] absolute -top-[70px] -right-[10px] lg:-right-[70px]">
                            <img src={imgs["imgLock"]} width={"100%"} height={"auto"} className="" />
                        </span>
                    </div>
                    <form
                        className="find-body rounded-b-[30px] p-[40px] pt-[70px] bg-card flex flex-col gap-[70px] shadow-lg "
                        onSubmit={handleSubmitChange}
                    >
                        <div className="find-body-min flex flex-col gap-[14px]">
                            <p className="flex gap-[5px]">
                                <label htmlFor="usernumber" className="block w-[120px] text-sm pt-[8px]">
                                    Current Password
                                    <span className="text-error ml-0.5">*</span>
                                </label>
                                <span className="flex flex-col gap-[4px] w-full">
                                    <input
                                        id="usrPwd"
                                        type="password"
                                        className="text-sm input bg-transparent h-[36px] w-full"
                                        value={usrPwd}
                                        onChange={(event) =>
                                            setChangePasswordForm((prev) => ({ ...prev, usrPwd: event.target.value }))
                                        }
                                    />
                                </span>
                            </p>
                            <p className="flex gap-[5px]">
                                <label htmlFor="usernumber" className="block w-[120px] text-sm pt-[8px]">
                                    New Password
                                    <span className="text-error ml-0.5">*</span>
                                </label>
                                <span className="flex flex-col gap-[4px] w-full">
                                    {/* <input
                                        id="usernumber"
                                        type="password"
                                        className="text-sm input bg-transparent h-[36px] w-full"
                                        value={newUsrPwd}
                                        onChange={(event) =>
                                            setChangePasswordForm((prev) => ({
                                                ...prev,
                                                newUsrPwd: event.target.value,
                                            }))
                                        }
                                    /> */}
                                    <InputPassword
                                        className="text-sm input bg-transparent h-[36px] w-full"
                                        value={newUsrPwd}
                                        onChange={(event) =>
                                            setChangePasswordForm((prev) => ({
                                                ...prev,
                                                newUsrPwd: event,
                                            }))
                                        }
                                    />
                                </span>
                            </p>
                            <p className="flex gap-[5px]">
                                <label htmlFor="usernumber" className="block w-[120px] text-sm pt-[8px]">
                                    Confirm New Password
                                    <span className="text-error ml-0.5">*</span>
                                </label>
                                <span className="flex flex-col gap-[4px] w-full">
                                    {/* <input
                                        id="usernumber"
                                        type="password"
                                        className="text-sm input bg-transparent h-[36px] w-full"
                                        value={newUsrPwdCheck}
                                        onChange={(event) =>
                                            setChangePasswordForm((prev) => ({
                                                ...prev,
                                                newUsrPwdCheck: event.target.value,
                                            }))
                                        }
                                    /> */}
                                    <InputPassword
                                        className="text-sm input bg-transparent h-[36px] w-full"
                                        value={newUsrPwdCheck}
                                        onChange={(event) =>
                                            setChangePasswordForm((prev) => ({
                                                ...prev,
                                                newUsrPwdCheck: event,
                                            }))
                                        }
                                    />
                                </span>
                            </p>
                        </div>
                        <div className="flex gap-[10px]">
                            <button
                                type="submit"
                                className={classNames(
                                    "w-full rounded-[32px] h-[60px] text-base bg-primary-fill-5 border border-primary text-primary dark:text-white dark:border-white dark:hover:border-primary",
                                    "hover:bg-primary hover:text-white hover:border-primary",
                                )}
                            >
                                Change Password
                            </button>

                            {auth.get("pwdIntzYn") === "N" && (
                                <button
                                    className={classNames(
                                        "w-full rounded-[32px] h-[60px] text-base border border-darkgray bg-darkgray-fill-5 text-darkgray dark:text-white dark:border-white dark:hover:border-darkgray",
                                        "hover:bg-darkgray hover:text-white hover:border-darkgray dark:hover:text-black",
                                    )}
                                    onClick={handleSubmitChangeSkip}
                                >
                                    Change later
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;
